// extracted by mini-css-extract-plugin
export default {"header":"TeslaHeader_header__1zGa4","container":"TeslaHeader_container__WC+WJ","logo":"TeslaHeader_logo__eEjSC"};